export enum channel {
  HOTEL = "HOTEL",
  PACKAGE = "PACKAGE",
}
